import { init, registerRemotes, loadRemote } from "@module-federation/runtime";
import type { ComponentType } from "react";
import * as React from "react";
import * as ReactDOM from "react-dom";

let initialized = false;
const registered = new Set<string>();

function ensureInit() {
  if (initialized) return;
  init({
    name: "insight_labs_host",
    remotes: [],
    shared: {
      react: {
        version: React.version,
        lib: () => React,
        shareConfig: { singleton: true, requiredVersion: false },
      },
      "react-dom": {
        version: ReactDOM.version,
        lib: () => ReactDOM,
        shareConfig: { singleton: true, requiredVersion: false },
      },
    },
  });
  initialized = true;
}

/** Derive the federation scope name from a lab ID (matches Labs-Card CLI convention) */
function toScope(labId: string): string {
  return labId.replace(/[^a-zA-Z0-9_]/g, "_");
}

export async function loadLabCard(
  labId: string,
  _cardUrl: string,
  cardScope?: string
): Promise<ComponentType> {
  ensureInit();

  const scope = cardScope || toScope(labId);

  // Route all card loads through the same-origin proxy
  const proxyUrl = `/api/card-proxy/${labId}/remoteEntry.js`;

  if (!registered.has(scope)) {
    registerRemotes([{ name: scope, entry: proxyUrl }]);
    registered.add(scope);
  }

  const mod = await loadRemote<Record<string, unknown>>(`${scope}/Card`);
  if (!mod) throw new Error(`No module returned for ${labId}/Card`);

  const Comp =
    (mod as { default?: ComponentType }).default ||
    (Object.values(mod).find((v) => typeof v === "function") as ComponentType | undefined);

  if (!Comp) throw new Error(`No component found in ${labId}/Card`);
  return Comp;
}
